import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';

const services = [
  {
    icon: 'ri-computer-line',
    title: 'Formatação de Micros e Notebooks',
    description: 'Formatação completa com instalação do sistema operacional, drivers e programas essenciais. Deixamos seu computador rápido e seguro como se fosse novo.',
    items: ['Formatação Windows 10/11', 'Instalação de drivers', 'Configuração de programas essenciais', 'Backup de dados (opcional)', 'Antivírus e proteção'],
    image: 'https://readdy.ai/api/search-image?query=technician%20carefully%20formatting%20laptop%20computer%20in%20professional%20IT%20workshop%2C%20clean%20white%20desk%2C%20tools%20visible%2C%20teal%20and%20navy%20color%20accents%2C%20high%20quality%20photography%2C%20modern%20tech%20environment&width=700&height=450&seq=pg001&orientation=landscape',
  },
  {
    icon: 'ri-cpu-line',
    title: 'Montagem de Computadores Gamers',
    description: 'Montagem personalizada de PCs gamers e workstations com os melhores componentes do mercado. Ajudamos você a escolher as peças certas dentro do seu orçamento.',
    items: ['Consultoria de componentes', 'Montagem completa', 'Instalação do sistema', 'Teste de estabilidade', 'Garantia na montagem'],
    image: 'https://readdy.ai/api/search-image?query=high%20end%20gaming%20PC%20build%20with%20RGB%20lighting%20inside%20tempered%20glass%20case%2C%20colorful%20components%20visible%2C%20dark%20background%20with%20teal%20and%20blue%20glow%2C%20professional%20photography%2C%20premium%20gaming%20setup&width=700&height=450&seq=pg002&orientation=landscape',
  },
  {
    icon: 'ri-tools-line',
    title: 'Limpeza e Manutenção',
    description: 'Limpeza interna completa de notebooks e computadores, troca de pasta térmica e manutenção preventiva para maior durabilidade e desempenho.',
    items: ['Limpeza interna completa', 'Troca de pasta térmica', 'Verificação de hardware', 'Manutenção preventiva', 'Diagnóstico completo'],
    image: 'https://readdy.ai/api/search-image?query=technician%20performing%20detailed%20cleaning%20of%20laptop%20motherboard%20with%20precision%20tools%2C%20professional%20computer%20maintenance%20workshop%2C%20clean%20white%20background%2C%20technical%20repair%20environment%2C%20high%20quality&width=700&height=450&seq=pg003&orientation=landscape',
  },
  {
    icon: 'ri-remote-control-line',
    title: 'Suporte Remoto',
    description: 'Resolva problemas sem sair de casa! Acesso remoto seguro para diagnóstico e solução de problemas de software de forma rápida e prática.',
    items: ['Acesso remoto seguro', 'Diagnóstico de software', 'Remoção de vírus', 'Configurações do sistema', 'Suporte para empresas'],
    image: 'https://readdy.ai/api/search-image?query=IT%20support%20technician%20working%20remotely%20on%20dual%20monitors%20with%20remote%20desktop%20connection%20interface%2C%20professional%20home%20office%2C%20teal%20and%20navy%20color%20scheme%2C%20modern%20workspace%2C%20technology%20concept&width=700&height=450&seq=pg004&orientation=landscape',
  },
  {
    icon: 'ri-install-line',
    title: 'Instalação de Softwares',
    description: 'Instalação e configuração de sistemas operacionais, pacotes Office, antivírus, drivers e qualquer software que você precisar, de forma rápida e correta.',
    items: ['Windows e Linux', 'Pacote Office', 'Antivírus e segurança', 'Drivers e utilitários', 'Softwares específicos'],
    image: 'https://readdy.ai/api/search-image?query=software%20installation%20progress%20on%20modern%20computer%20screen%2C%20professional%20IT%20setup%2C%20clean%20desk%20environment%2C%20teal%20and%20blue%20interface%20design%2C%20modern%20technology%20workspace%2C%20high%20quality%20photo&width=700&height=450&seq=pg005&orientation=landscape',
  },
  {
    icon: 'ri-briefcase-line',
    title: 'Consultoria em TI',
    description: 'Consultoria especializada para empresas: infraestrutura de rede, segurança da informação, escolha de equipamentos e soluções tecnológicas sob medida.',
    items: ['Análise de infraestrutura', 'Configuração de redes', 'Segurança da informação', 'Escolha de equipamentos', 'Suporte contínuo'],
    image: 'https://readdy.ai/api/search-image?query=IT%20consultant%20presenting%20technology%20solutions%20to%20business%20team%20in%20modern%20office%2C%20laptop%20and%20documents%20on%20table%2C%20professional%20corporate%20environment%2C%20teal%20and%20navy%20color%20accents%2C%20business%20meeting&width=700&height=450&seq=pg006&orientation=landscape',
  },
  {
    icon: 'ri-code-s-slash-line',
    title: 'Criação de Sites Personalizados',
    description: 'Desenvolvemos sites modernos, responsivos e otimizados para o Google. Criamos a presença digital ideal para sua empresa crescer online e atrair mais clientes.',
    items: ['Design exclusivo e moderno', 'Responsivo para celular e tablet', 'Otimização para Google (SEO)', 'Landing pages e portfólios', 'Manutenção e suporte'],
    image: 'https://readdy.ai/api/search-image?query=web%20designer%20working%20on%20modern%20website%20design%20on%20large%20monitor%20in%20creative%20digital%20agency%2C%20teal%20and%20dark%20navy%20color%20scheme%2C%20code%20editor%20and%20design%20mockups%20visible%2C%20professional%20modern%20office%20environment%2C%20high%20quality%20photography&width=700&height=450&seq=pg007&orientation=landscape',
  },
];

const schemaData = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'Serviços de Informática - JampaBit',
  description: 'Lista completa de serviços de suporte técnico em TI oferecidos pela JampaBit em João Pessoa, PB.',
  url: `${import.meta.env.VITE_SITE_URL}/servicos`,
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      item: {
        '@type': 'Service',
        name: 'Formatação de Micros e Notebooks',
        description: 'Formatação completa com instalação do sistema operacional, drivers e programas essenciais.',
        provider: { '@type': 'LocalBusiness', name: 'JampaBit Informática' },
        areaServed: { '@type': 'City', name: 'João Pessoa' },
      },
    },
    {
      '@type': 'ListItem',
      position: 2,
      item: {
        '@type': 'Service',
        name: 'Montagem de Computadores Gamers',
        description: 'Montagem personalizada de PCs gamers e workstations com os melhores componentes do mercado.',
        provider: { '@type': 'LocalBusiness', name: 'JampaBit Informática' },
        areaServed: { '@type': 'City', name: 'João Pessoa' },
      },
    },
    {
      '@type': 'ListItem',
      position: 3,
      item: {
        '@type': 'Service',
        name: 'Limpeza e Manutenção',
        description: 'Limpeza interna completa de notebooks e computadores, troca de pasta térmica e manutenção preventiva.',
        provider: { '@type': 'LocalBusiness', name: 'JampaBit Informática' },
        areaServed: { '@type': 'City', name: 'João Pessoa' },
      },
    },
    {
      '@type': 'ListItem',
      position: 4,
      item: {
        '@type': 'Service',
        name: 'Suporte Remoto',
        description: 'Acesso remoto seguro para diagnóstico e solução de problemas de software.',
        provider: { '@type': 'LocalBusiness', name: 'JampaBit Informática' },
        areaServed: { '@type': 'City', name: 'João Pessoa' },
      },
    },
    {
      '@type': 'ListItem',
      position: 5,
      item: {
        '@type': 'Service',
        name: 'Instalação de Softwares',
        description: 'Instalação e configuração de sistemas operacionais, pacotes Office, antivírus e drivers.',
        provider: { '@type': 'LocalBusiness', name: 'JampaBit Informática' },
        areaServed: { '@type': 'City', name: 'João Pessoa' },
      },
    },
    {
      '@type': 'ListItem',
      position: 6,
      item: {
        '@type': 'Service',
        name: 'Consultoria em TI',
        description: 'Consultoria especializada para empresas: infraestrutura de rede, segurança da informação e soluções tecnológicas.',
        provider: { '@type': 'LocalBusiness', name: 'JampaBit Informática' },
        areaServed: { '@type': 'City', name: 'João Pessoa' },
      },
    },
    {
      '@type': 'ListItem',
      position: 7,
      item: {
        '@type': 'Service',
        name: 'Criação de Sites Personalizados',
        description: 'Desenvolvemos sites modernos, responsivos e otimizados para o Google.',
        provider: { '@type': 'LocalBusiness', name: 'JampaBit Informática' },
        areaServed: { '@type': 'City', name: 'João Pessoa' },
      },
    },
  ],
};

export default function ServicosPage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-servicos';
    script.textContent = JSON.stringify(schemaData);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById('schema-servicos');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="bg-[#1a3a4a] pt-28 md:pt-32 pb-12 md:pb-16">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <div className="inline-flex items-center gap-2 border border-[#00c9a7]/40 text-[#00c9a7] text-xs font-semibold px-4 py-2 rounded-full mb-5 md:mb-6">
            <i className="ri-settings-3-line" />
            Nossos Serviços
          </div>
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 md:mb-5">
            Soluções Completas em <span className="text-[#00c9a7]">Informática</span>
          </h1>
          <p className="text-white/60 text-base md:text-lg max-w-xl mx-auto">
            Atendemos residências e empresas com qualidade, agilidade e preço justo. Vamos até você!
          </p>
        </div>
      </section>

      {/* Services */}
      <section className="py-12 md:py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-col gap-14 md:gap-20">
          {services.map((service, idx) => (
            <div
              key={service.title}
              className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center"
            >
              <div className={idx % 2 === 1 ? 'lg:order-2' : ''}>
                <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-[#00c9a7]/10 mb-4 md:mb-5">
                  <i className={`${service.icon} text-[#00c9a7] text-2xl`} />
                </div>
                <h2 className="text-xl md:text-3xl font-bold text-[#0d1b2a] mb-3 md:mb-4">{service.title}</h2>
                <p className="text-gray-500 text-sm md:text-base leading-relaxed mb-4 md:mb-6">{service.description}</p>
                <ul className="space-y-2.5 md:space-y-3 mb-6 md:mb-8">
                  {service.items.map((item) => (
                    <li key={item} className="flex items-center gap-3 text-sm text-gray-600">
                      <div className="w-5 h-5 flex items-center justify-center rounded-full bg-[#00c9a7]/15 flex-shrink-0">
                        <i className="ri-check-line text-[#00c9a7] text-xs" />
                      </div>
                      {item}
                    </li>
                  ))}
                </ul>
                <a
                  href="https://wa.me/5583991755663?text=Ol%C3%A1!%20Gostaria%20de%20solicitar%20um%20or%C3%A7amento."
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="inline-flex items-center gap-2 bg-[#00c9a7] hover:bg-[#00b396] text-white font-semibold px-6 py-3 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
                >
                  <i className="ri-whatsapp-line" />
                  Solicitar Orçamento
                </a>
              </div>
              <div className={`rounded-2xl overflow-hidden h-56 sm:h-64 lg:h-80 ${idx % 2 === 1 ? 'lg:order-1' : ''}`}>
                <img src={service.image} alt={service.title} className="w-full h-full object-cover object-top" />
              </div>
            </div>
          ))}
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
